import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PaymentModal = ({ showModal, setShowModal, payment, processPayment, cardDetails, setCardDetails }) => {
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        if (showModal) {
            setAnimate(true);
        } else {
            setTimeout(() => setAnimate(false), 300);
        }
    }, [showModal]);

    if (!animate) return null;

    function handleCardInputChange(event) {
        const { name, value } = event.target;
        setCardDetails((prev) => ({ ...prev, [name]: value }));
    }

    return (
        <>
            {/* Backdrop */}
            <div className={`modal-backdrop fade ${showModal ? "show" : ""}`} onClick={() => setShowModal(false)}></div>

            {/* Bottom Modal */}
            <div
                className={`modal d-block ${showModal ? "show" : ""}`}
                tabIndex="-1"
                role="dialog"
                style={{
                    position: "fixed",
                    bottom: 0,
                    left: "50%",
                    transform: showModal ? "translateX(-50%) translateY(0)" : "translateX(-50%) translateY(100%)",
                    width: "100%",
                    maxWidth: "600px",
                    transition: "transform 0.3s ease-in-out",
                    zIndex: 1050,
                }}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content rounded-top">
                        <div className="modal-header">
                            <h5 className="modal-title">Betala med {payment}</h5>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className="modal-body">
                            {payment === "card" && (
                                <>
                                    <label>Kortnummer</label>
                                    <input type="text" className="form-control mb-2" name="number" value={cardDetails.number} onChange={handleCardInputChange} placeholder="1234 5678 9012 3456" />
                                    <label>Utgångsdatum</label>
                                    <input type="text" className="form-control mb-2" name="expiry" value={cardDetails.expiry} onChange={handleCardInputChange} placeholder="MM/YY" />
                                    <label>CVV</label>
                                    <input type="text" className="form-control" name="cvv" value={cardDetails.cvv} onChange={handleCardInputChange} placeholder="123" />
                                </>
                            )}

                            {payment === "swish" && (
                                <>
                                    <p className="text-center">Skanna QR-koden för att betala med Swish</p>
                                    <img src="https://via.placeholder.com/250" alt="Swish QR Code" className="d-block mx-auto mb-2" />
                                    <button className="btn btn-success w-100">Använd denna telefon</button>
                                </>
                            )}

                            {payment === "google" && (
                                <button className="btn btn-dark w-100">
                                    <img src="https://developers.google.com/static/pay/api/images/brand-guidelines/google-pay-mark.png" alt="Google Pay" style={{ height: "30px", objectFit: "contain" }} />
                                </button>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary primaryText w-100" onClick={() => {
                                processPayment();
                                setShowModal(false);
                            }}>
                                Slutför betalning
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentModal;
